<template>
    <!-- Objects types -->
    <el-form-item no-help :label="$t(label)" prop="typeObjet">
        <el-cascader
                v-model="filter.typeObjets"
                :options="optionsObjectTypes"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                @input="objectTypes => addFilter({ objectTypes })"
                clearable
                filterable
        ></el-cascader>
    </el-form-item>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { getObjectTypes } from '../../../services/postsData'
import _groupBy from 'lodash/groupBy'
import _keyBy from 'lodash/keyBy'
import _omit from 'lodash/omit'
import _remove from 'lodash/remove'
import _each from 'lodash/each'
import _values from 'lodash/values'
import _filter from 'lodash/filter'

export default {
  name: 'PostFilterObjectType',
  props: {
    label: { type: String, default: 'Type de bien' },
    minLevel: { type: Number, default: 1 },
    maxLevel: { type: Number, default: 99 },
    isLot: { type: Boolean, default: false }
  },
  data: function () {
    return {
      objectTypes: [],
      type_objet: [],
      optionsObjectTypes: []
    }
  },
  watch: {
    annonceParente: async function (val) {
      if (this.isLot) {
        this.type_objet = await getObjectTypes(this.filter.annonceParente, this.sitimmoUserLogin)
      } else {
        this.type_objet = await getObjectTypes(this.filter.annonceParente)
      }
      if (this.type_objet.type == 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.optionsObjectTypes = this.objectTypesTree(this.type_objet)
    }
  },
  async beforeMount () {
    if (this.isLot) {
      this.type_objet = await getObjectTypes(this.filter.annonceParente, this.sitimmoUserLogin)
    } else {
      if (this.isBailleurSocial) {
        this.type_objet = await getObjectTypes(0)
      } else {
        this.type_objet = await getObjectTypes(this.filter.annonceParente)
      }
    }
    if (this.type_objet.type === 'error') {
      // this.$message({message: this.$t("error.found"), type: 'error'});
      this.loading = false
      return false
    }
    this.optionsObjectTypes = this.objectTypesTree(this.type_objet)
  },
  computed: {
    ...mapState('posts', ['filter']),
    annonceParente () {
      return this.filter.annonceParente
    },
    sitimmoUserLogin () {
      return this.sitimmoUser.login
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    }
  },
  methods: {
    ...mapMutations('posts', [
      'addFilter'
    ]),
    objectTypesTree (data) {
      _remove(data, function (currentObject) {
        return currentObject.niveau < this.minLevel || currentObject.niveau > this.maxLevel
      }.bind(this))

      _each(data, function (object) {
        object.value = object.code
        object.label = object.libelle
      })

      const groupedByParents = _groupBy(data, 'parentCode')
      const objectsByCode = _keyBy(data, 'code')

      _each(_omit(groupedByParents, undefined), function (children, parentCode) {
        if (objectsByCode[parentCode]) {
          objectsByCode[parentCode].children = children
        }
      })

      return _filter(objectsByCode, function (object) {
        return object.niveau >= this.minLevel
      }.bind(this))
    }
  }
}
</script>
